import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { SearchEmployeesToManageResponseModel } from '../../../model/searchEmployeesToManageResponseModel';
import { SelectEmployeesToManageRequestModel } from '../../../model/selectEmployeesToManageRequestModel';
import { UnselectEmployeesToManageRequestModel } from '../../../model/unselectEmployeesToManageRequestModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { ManageEmployeeListModel } from '../../../model/manageEmployeeListModel';
import { Subscription } from 'rxjs';
import { TransferEmployerCloseOfficeService } from '../transfer-employer-close-office.service';
import { StorageService } from '../../../shared/security/StorageService';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { Router } from '@angular/router';
import { OfficeSelectableListModel } from '../../../model/officeSelectableListModel';

@Component({
  selector: 'app-confirm-close-office',
  templateUrl: './confirm-close-office.component.html',
  styleUrls: ['./confirm-close-office.component.css']
})
export class ConfirmCloseOfficeComponent implements OnInit, OnDestroy {
  

  searchEmployeesToManageResponseModel: SearchEmployeesToManageResponseModel = new SearchEmployeesToManageResponseModel();
  selectEmployeesModel: SelectEmployeesToManageRequestModel = new SelectEmployeesToManageRequestModel();
  unselectEmployeesRequestModel: UnselectEmployeesToManageRequestModel = new UnselectEmployeesToManageRequestModel();
  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel = new WorkflowModel();
  title: string = "";
  manageEmployeeListToSubmit : Array<ManageEmployeeListModel> =[];
  getNotifyWorkflowModelSubscription : Subscription;

  officesList: Array<OfficeSelectableListModel> = [];

  
  constructor(private transferEmployerCloseOfficeService: TransferEmployerCloseOfficeService,
    private storage: StorageService,
    private currentPageWatcher: CurrentPageWatcherService,
    private startFunctionService: StartFunctionService,
    private router: Router) {

    this.startFunction = this.storage.getStartFunctionData();
    if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
      this.title = this.startFunction.Workflow.WorkflowDisplayName;
    }

    this.transferEmployerCloseOfficeService.getNotifyManageEmployeeList().subscribe(
      (data:Array<ManageEmployeeListModel>)=>{
        this.manageEmployeeListToSubmit=data;
      });
    
      this.getNotifyWorkflowModelSubscription= this.transferEmployerCloseOfficeService.getNotifyWorkflowModel().subscribe(workflowData=>{
      this.workflow=workflowData;
    })

    this.transferEmployerCloseOfficeService.getNotifySearchEmployeesToManageResponseModel().subscribe(searchEmployeesToManageResponseData=>{
      this.searchEmployeesToManageResponseModel = searchEmployeesToManageResponseData;
    });

    this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().subscribe( selectEmployeesData=>{
      this.selectEmployeesModel = selectEmployeesData;
    });
  }
  ngOnInit() {

    
    this.transferEmployerCloseOfficeService.getOfficesToClose(this.workflow.WorkflowID).subscribe(
      response => {
console.log(response);
        response.forEach(el => {
          this.officesList.push(el);
        });

      });
  }
  continue() {
    this.currentPageWatcher.sendUserMessages(null);
      this.router.navigate(["/severTransferReview"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(true);
        this.transferEmployerCloseOfficeService.getNotifyManageEmployeeList().emit(this.manageEmployeeListToSubmit);
        this.transferEmployerCloseOfficeService.getNotifyWorkflowModel().emit(this.workflow);
        this.transferEmployerCloseOfficeService.getNotifySearchEmployeesToManageResponseModel().emit(this.searchEmployeesToManageResponseModel);
        this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().emit(this.selectEmployeesModel);
  
      });
    }

    goBack() {
      this.router.navigate(["/listCancelActions"]).then(() => {
        this.transferEmployerCloseOfficeService.getNotifySearchEmployeesToManageResponseModel().emit(this.searchEmployeesToManageResponseModel);
        this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().emit(this.selectEmployeesModel);
        this.startFunctionService.getNotifyStepInProgress().emit(false);
  
      })
  
    }
  
    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
      this.router.navigate(["/listCancelActions"]).then(() => {
        this.transferEmployerCloseOfficeService.getNotifySearchEmployeesToManageResponseModel().emit(this.searchEmployeesToManageResponseModel);
        this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().emit(this.selectEmployeesModel);
        this.startFunctionService.getNotifyStepInProgress().emit(false);
  
      })
    }

    ngOnDestroy(): void {
      this.currentPageWatcher.clearUserMessage();
      this.currentPageWatcher.clearStepMessage();
    }
}



// WEBPACK FOOTER //
// ./src/app/broker/transfer-employer-close-office/confirm-close-office/confirm-close-office.component.ts